import React, { useState } from 'react';

const C = {
  bg:'#06070b', bg2:'#0d1118', bg3:'#141a24',
  blue:'#4ba3ff', blueL:'rgba(75,163,255,0.14)', blueB:'rgba(176,202,233,0.2)',
  white:'#ffffff', grey:'#9ea6b4', grey2:'#d7dde8', grey3:'#2a3442',
  green:'#46d369', red:'#ff5a54', gold:'#f1c66d', border:'rgba(176,202,233,0.12)',
};

export function PaywallModal({onClose, onSubscribe, show}) {
  const plans = [
    {
      id:'viewer',
      name:'Founding Viewer Plan',
      price:'R49',
      period:'/month',
      color:C.blue,
      badge:'LAUNCH OFFER',
      features:[
        'Founding viewer price for the first 6 months after launch',
        'Access to SA Originals, Sports, Talk Shows and Podcasts at launch',
        'Early access updates before the platform opens publicly',
        'Tip your favourite creators when tipping goes live',
        'Ads supported',
        'No lock-in contract',
      ],
    },
  ];

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(3,6,10,0.84)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000,padding:24,backdropFilter:'blur(14px)'}}>
      <div style={{background:'radial-gradient(circle at 82% 12%, rgba(241,198,109,0.07) 0%, transparent 20%), linear-gradient(180deg,rgba(17,25,37,0.98),rgba(12,18,28,0.98))',borderRadius:30,maxWidth:700,width:'100%',overflow:'hidden',boxShadow:'0 40px 80px rgba(0,12,30,0.54)',border:`1px solid ${C.blueB}`}}>
        {/* Header */}
        <div style={{padding:'34px 34px 24px',borderBottom:`1px solid ${C.border}`,position:'relative'}}>
          <button onClick={onClose} style={{position:'absolute',top:18,right:18,background:'none',border:'none',color:C.grey,cursor:'pointer',fontSize:22,lineHeight:1}}>✕</button>
          <div style={{fontFamily:'Arial',fontSize:13,fontWeight:900,letterSpacing:4,color:C.blue,marginBottom:10}}>VAULTT</div>
          {show ? (
            <>
              <div style={{fontSize:16,fontWeight:700,color:C.grey2,marginBottom:10}}>
                Continue watching
              </div>
              <div style={{fontSize:34,fontWeight:900,color:C.white,letterSpacing:-1.1,lineHeight:1.02,marginBottom:10}}>
                {show.title}
              </div>
              <div style={{fontSize:15,color:C.grey2,lineHeight:1.7,maxWidth:560}}>
                You’ve reached the end of the free preview. Join viewer early access to stay first in line when full access opens.
              </div>
            </>
          ) : (
            <>
              <div style={{fontSize:16,fontWeight:700,color:C.grey2,marginBottom:10}}>
                Viewer access
              </div>
              <div style={{fontSize:34,fontWeight:900,color:C.white,letterSpacing:-1.1,lineHeight:1.02,marginBottom:10}}>
                Unlock all of VAULTT
              </div>
              <div style={{fontSize:15,color:C.grey2,lineHeight:1.7,maxWidth:560}}>
                Subscribe to access SA Originals, Sports, Talk Shows, Podcasts and more.
              </div>
            </>
          )}
        </div>

        {/* Plans */}
        <div style={{padding:'26px 34px',display:'grid',gridTemplateColumns:'1fr',gap:14,borderBottom:`1px solid ${C.border}`}}>
          {plans.map(plan=>(
            <div key={plan.id}
              style={{border:`1px solid ${C.blueB}`,borderRadius:24,padding:24,background:'radial-gradient(circle at 86% 12%, rgba(241,198,109,0.08) 0%, transparent 20%), linear-gradient(180deg,rgba(18,33,52,0.92),rgba(14,24,36,0.94))',transition:'all 0.2s',position:'relative',boxShadow:'inset 0 1px 0 rgba(255,255,255,0.04)'}}>
              {plan.badge && (
                <div style={{position:'absolute',top:14,right:16,background:'rgba(241,198,109,0.12)',border:'1px solid rgba(241,198,109,0.22)',color:'#f3dfb4',fontSize:9,fontWeight:900,letterSpacing:1.8,padding:'5px 11px',borderRadius:999}}>{plan.badge}</div>
              )}
              <div style={{fontSize:14,fontWeight:700,color:C.white,marginBottom:8}}>{plan.name}</div>
              <div style={{display:'flex',alignItems:'baseline',gap:4,marginBottom:16}}>
                <span style={{fontFamily:'Arial',fontSize:48,fontWeight:900,color:C.white,letterSpacing:-1.2}}>{plan.price}</span>
                <span style={{fontSize:13,color:C.grey,marginBottom:8}}>{plan.period}</span>
              </div>
              {plan.features.map((f,i)=>(
                <div key={i} style={{display:'flex',gap:10,alignItems:'flex-start',marginBottom:8}}>
                  <span style={{color:C.green,flexShrink:0,fontSize:12,marginTop:1}}>✓</span>
                  <span style={{fontSize:13,color:C.grey2,lineHeight:1.5}}>{f}</span>
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{padding:'24px 34px 28px'}}>
          <button onClick={()=>onSubscribe('viewer')}
            style={{width:'100%',padding:17,background:'linear-gradient(135deg,#66b2ff,#2f8fff)',color:C.white,border:'none',borderRadius:999,fontSize:17,fontWeight:800,cursor:'pointer',fontFamily:'inherit',marginBottom:14,transition:'all 0.2s',boxShadow:'0 18px 36px rgba(75,163,255,0.24)'}}>
            Join Viewer Early Access
          </button>
          <div style={{textAlign:'center',fontSize:12,color:C.grey,lineHeight:1.6}}>
            Viewer pricing is R49/month for the first 6 months after launch. Billing will only begin once subscriptions officially open.
          </div>
          <div style={{textAlign:'center',fontSize:12,color:C.grey2,marginTop:12,lineHeight:1.6,position:'relative',zIndex:9999,pointerEvents:'auto'}}>
            By continuing, you agree to VAULTT's{' '}
            <span
              onClick={() => window.open('/VAULTT_Terms_of_Service.pdf', '_blank', 'noopener,noreferrer')}
              style={{color:C.blue,cursor:'pointer',textDecoration:'underline',position:'relative',zIndex:9999,pointerEvents:'auto'}}
            >
              Terms of Service
            </span>{' '}
            and{' '}
            <span
              onClick={() => window.open('/VAULTT_Privacy_Policy.pdf', '_blank', 'noopener,noreferrer')}
              style={{color:C.blue,cursor:'pointer',textDecoration:'underline',position:'relative',zIndex:9999,pointerEvents:'auto'}}
            >
              Privacy Policy
            </span>.
          </div>
          <div style={{textAlign:'center',marginTop:12}}>
            <span onClick={onClose} style={{fontSize:12,color:C.grey,cursor:'pointer',textDecoration:'underline'}}>Continue with free access →</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export function FreeEpisodeBanner({episodesWatched, freeLimit, onSubscribe}) {
  const remaining = freeLimit - episodesWatched;
  if (remaining > 1) return null;

  return (
    <div style={{background:`radial-gradient(circle at 84% 16%, rgba(241,198,109,0.08) 0%, transparent 18%), linear-gradient(135deg,rgba(18,33,52,0.9),rgba(14,24,36,0.94))`,border:`1px solid ${C.blueB}`,borderRadius:18,padding:'14px 18px',marginBottom:16,display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'inset 0 1px 0 rgba(255,255,255,0.04)'}}>
      <div>
        <div style={{fontSize:13,fontWeight:700,color:C.white,marginBottom:3}}>
          {remaining === 1 ? '⚠️ Last free episode' : '🔒 Free preview complete'}
        </div>
        <div style={{fontSize:12,color:C.grey2}}>
          {remaining === 1
            ? 'Join viewer early access to hear when full access opens.'
            : 'Join viewer early access for launch updates and access details.'}
        </div>
      </div>
      <button onClick={onSubscribe}
        style={{padding:'9px 20px',background:'linear-gradient(135deg,#66b2ff,#2f8fff)',color:C.white,border:'none',borderRadius:999,fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'inherit',whiteSpace:'nowrap',marginLeft:16,flexShrink:0,boxShadow:'0 12px 24px rgba(75,163,255,0.2)'}}>
        Join Early Access →
      </button>
    </div>
  );
}
